import { createContext, useContext } from 'react';

import type { StagedValueStore } from './create-staged-value-store';

const StagedValueContext = createContext<StagedValueStore | null>(null);

export const StagedValueProvider = StagedValueContext.Provider;

export function useStagedValueContext() {
  const context = useContext(StagedValueContext);

  if (!context) {
    throw new Error('useStagedValueContext must be used within a StagedValueProvider.');
  }

  return context;
}
